import Vue from 'vue'
import Vuex from 'vuex'

import trip from './modules/trip'
import members from './modules/members'
import points from './modules/points'
import decisions from './modules/decisions'
import infoItems from './modules/infoItems'
import todos from './modules/todos'
import finance from './modules/finance'
import moments from './modules/moments'
import ui from './modules/ui'

import { loadPersisted, persistPlugin, clearPersisted } from './persist'
import { computeTripStage } from './modules/trip'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { trip, members, points, decisions, infoItems, todos, finance, moments, ui },
  getters: {
    // 對應 3.1.2：綜合日期與 Moment 時間，算出 Trip 目前處於規劃中／旅行中／已結束。
    tripStage: (state, getters) => tripId => {
      const trip = getters['trip/byId'](tripId)
      if (!trip) return 'planning'
      const first = getters['moments/firstCapturedAt'](tripId)
      return computeTripStage(trip, first ? [first] : [])
    }
  },
  actions: {
    resetDemoData () {
      clearPersisted()
      window.location.reload()
    }
  }
})

const persisted = loadPersisted()
if (persisted) {
  store.replaceState(Object.assign({}, store.state, persisted))
}
persistPlugin(store)

export default store
